/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import React, { useCallback } from 'react';
import { unstable } from '@broadleaf/admin-components';

const { ModalFormAction, SVG, MetadataUtils } = unstable;
const { getAttribute } = MetadataUtils;
const defaultClassName =
  'tw-flex tw-items-center tw-justify-start tw-w-full tw-py-4 tw-px-3 tw-text-gray-700 tw-border-t tw-border-gray-300 tw-font-medium tw-text-lg tw-whitespace-no-wrap tw-bg-gray-100 hover:tw-bg-gray-200 hover:tw-text-gray-900 focus:tw-bg-gray-200 focus:tw-text-gray-900 focus:tw-outline-none active:tw-bg-gray-300 md:tw-py-2 md:tw-text-sm';

const ViewExports = props => {
  const { actionDefinition, readOnly: disabled = false } = props;
  const renderAction = useCallback(
    ({ toggleOpen }) => (
      <button
        className={defaultClassName}
        disabled={disabled}
        onClick={toggleOpen}
      >
        <SVG
          className="tw-mr-2 tw-inline tw-h-4 tw-w-4 tw-fill-current"
          name="download"
        />{' '}
        {actionDefinition.label}
      </button>
    ),
    [actionDefinition, disabled]
  );

  return (
    <ModalFormAction
      components={actionDefinition.components}
      disabled={disabled}
      onSubmit={() => {
        return Promise.resolve();
      }}
      renderAction={renderAction}
      submitLabel={getAttribute(actionDefinition, 'submitLabel', 'Close')}
      title={actionDefinition.label}
      tooltipPlacement={'top'}
    />
  );
};

export default ViewExports;
export { ViewExports };
